import axios from "../axios";
import h from "../helpers";
import { clientIp } from "../api-address";

const productCode = {
  index: async (params) => {
    const { data } = await axios.get(h.baseUrl("product-code"), {
      params: { ...params },
    });
    return data;
  },
  show: async (id) => {
    const { data } = await axios.get(h.baseUrl("product-code/" + id));
    return data;
  },
  store: async (
    sales_order_id,
    product_variant_id,
    warehouse_id,
    sales_channel_id,
    qr_code,
    scan_packing_date,
    scan_delivery_date,
    scan_retur_date,
    scan_scrap_date,
    status
  ) => {
    const { data } = await axios.post(h.baseUrl("product-code"), {
      sales_order_id,
      product_variant_id,
      warehouse_id,
      sales_channel_id,
      qr_code,
      scan_packing_date,
      scan_delivery_date,
      scan_retur_date,
      scan_scrap_date,
      status,
      ip_address: await clientIp(),
    });
    return data;
  },
  update: async (
    id,
    params
  ) => {
    const { data } = await axios.put(h.baseUrl("product-code/" + id), {
      ...params,
      ip_address: await clientIp(),
    });
    return data;
  },
  delete: async (id) => {
    const ip = await clientIp();
    const { data } = await axios.delete(
      h.baseUrl("product-code/" + id + `?ip_address=${ip}`)
    );
    return data;
  },
};

export default productCode;
